import { saLimitedReleasesListConstants } from "../_redux-constants";

export function saLimitedReleasesListReducer(
  state = {
    saLimitedReleasesListLoading: false,
    saLimitedReleasesListData: null,
    saLimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        saLimitedReleasesListLoading: true,
        saLimitedReleasesListData: null,
        saLimitedReleasesListError: null,
      });
    case saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        saLimitedReleasesListLoading: false,
        saLimitedReleasesListData: action.data,
      });
    case saLimitedReleasesListConstants.SA_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        saLimitedReleasesListLoading: false,
        saLimitedReleasesListData: null,
        saLimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
